<template>
  <el-row style="background:#fff; height:1000px;">
    <el-row style="width:70%; margin:0 auto;">
      <!-- 登录区 -->
      <el-row >
      <!-- banner -->
      <el-row class="banner"  >
        <el-row class="head">
          <el-col :span="22" class="head_logo" >
            <img :src="log1"  height="46px"/>
          </el-col>
          <!-- 增加用户信息，下拉菜单 -->
          <el-col :span="2" class="head_right">
            <div class="Head_Link">
              <el-button class="t" type="text" @click="handleButtonCommand('HomePage')">
                <!-- <i class="el-icon-third-shouye"></i> -->
                &nbsp;管理登录
              </el-button>
              <el-button class="t" type="text" :style="dh" style="padding-left:40px" >
                <!-- <i class="el-icon-star-off"></i> -->
                &nbsp;400-878-6390
              </el-button>
            </div>
          </el-col>
        </el-row> 
      </el-row>
        <!-- header is over -->
        <div class="content main">
          <div class="jf">
            <div class="dlck" style="float: left;">
              <h3 class="h3">
                    西安翻译学院
              </h3>
              <div>
              </div>
              <el-row style="margin-top: 14px">
                <el-form :model="global.curUser" ref="form" label-width="80px">
                  <el-form-item label="学生类型">
                    <el-select v-model="form.studentType" placeholder="== 请选择 ==">
                      <el-option v-for="option in stuTypeList" :key="option.modeId" :label="option.modeName" :class="Ginkgo.getEditItemClass(global.editInline)" :value="option.modeId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="学生姓名">
                    <el-input v-model="form.studentName" placeholder="请输入" :class="Ginkgo.getEditItemClass(global.editInline)"></el-input>
                  </el-form-item>
                  <el-form-item label="身份证号" v-show="idCardVisible">
                    <el-input v-model="form.idCard" placeholder="请输入" :class="Ginkgo.getEditItemClass(global.editInline)"></el-input>
                  </el-form-item>
                  <el-form-item label="学号" v-show="studentNoVisible">
                    <el-input v-model="form.studentNo" placeholder="请输入" :class="Ginkgo.getEditItemClass(global.editInline)"></el-input>
                  </el-form-item>
                </el-form>
                
                <el-row style="width:100%;margin: 20px auto;"><el-button style="width: 100%" type="success" @click="loginInit()">登录</el-button></el-row>
              </el-row>
            </div>
            <div style="width: 545px; height: 330px; float: right; margin-top:10px;">
              <!-- <div id="idContainer2" class="container" style="margin:8px 8px 0px 0px; background: #000; width: 590px; height: 370px;border:1px solid #CCC;" > -->
                <el-carousel indicator-position="outside" >
                  <el-carousel-item>
                    <img :src="fy1"  height="300px" width="545px"/>
                  </el-carousel-item>
                  <el-carousel-item>
                    <img :src="fy2" height="300px" width="545px"/>
                  </el-carousel-item>
                  <el-carousel-item>
                    <img :src="fy3" height="300px" width="545px"/>
                  </el-carousel-item>
                  <el-carousel-item>
                    <img :src="fy4" height="300px" width="545px"/>
                  </el-carousel-item>
                </el-carousel>
            </div>
          </div>
        </div>
        <div class="tybottom">
					<div class="main_down">
              <div class="down_gg fl">
                  <h2>咨询电话</h2>
                    <ul class="gg">
                      <li><span style="font-size: 16px;font-weight:bolder;">财务室：029-85891131</span></li>
                      <li><span style="font-size: 16px;font-weight:bolder;">公寓处：029-85891162</span></li>
                      <li><span style="font-size: 16px;font-weight:bolder;">教务处：029-85891148</span></li>
                      <li><span style="font-size: 16px;font-weight:bolder;">招生办：029-85896666</span></li>
                    </ul>
              </div>
 							<div class="down_gg fr">
     						<h2>帮助电话</h2>
 								<ul class="bzzx">
 								<li><span style="font-size: 18px;font-weight:bolder;">技术支持：400-878-6390</span></li>
 								<li><span style="font-size: 18px;font-weight:bolder;">信息管理中心：029-85891507</span></li>
 								<!-- <li><a target="_blank" style="font-size: 18px;font-weight:bolder;" href="OldStuBiaoZhun.jsp" >2017年春季老生学费标准</a></li> -->
 								<!-- <li><a style="font-size: 18px;font-weight:bolder;" href="javaScript:void()" onclick="getBoyHouse()">2016男生公寓分布</a></li> -->
 								</ul>
 							</div>
 					</div>
        </div>
        <!-- <div class="Copy">
            <el-row >
              <el-col style="font-size:14px;color:red;"><h2>合作银行</h2></el-col><el-col><img src="../../assets/images/xifan/citiclogo.png"/></el-col>
            </el-row>
					  <hr/>
              技术提供方　西安银杏软件有限公司　陕ICP备14001946号-2
            <br/>客服电话：4008786390
        </div> -->
        <div>
          <router-view></router-view>
        </div>
      </el-row>
     </el-row> 
  </el-row>
</template>
<script>
export default {
  name: 'MyBillSiYuan', // ?
  data: function () {
    return {
      dh: {
        backgroundImage: 'url(' + this.global.staticResourceAddr + 'gsvvuepcoif/images/xifan/phone' + '.png' + ')',
        backgroundRepeat: 'no-repeat'
      },
      stuTypeList: [
        {modeId: '01', modeName: '新生'},
        {modeId: '02', modeName: '老生'}
      ],
      form: {
        studentType: '02',
        studentName: '',
        studentNo: '',
        idCard: ''
      },
      idCardVisible: false,
      studentNoVisible: false,
      route: [],
      log1: this.global.staticResourceAddr + 'gsvvuepcoif/images/xifan/logo1.png',
      fy1: this.global.staticResourceAddr + 'gsvvuepcoif/images/xifan/fy1.jpg',
      fy2: this.global.staticResourceAddr + 'gsvvuepcoif/images/xifan/fy2.jpg',
      fy3: this.global.staticResourceAddr + 'gsvvuepcoif/images/xifan/fy3.jpg',
      fy4: this.global.staticResourceAddr + 'gsvvuepcoif/images/xifan/fy4.jpg'
    }
  },
  mounted: function () {
    if (process.env.NODE_ENV === 'production') {
      // 登录默认
      this.setVisible('02')
    } else {
      this.feeList = [
        {term: '1', feeAmount01: 1001, feeAmount02: 501, feeAmount03: 5011, feeNo: '01', feeType: '01'},
        {term: '2', feeAmount01: 1002, feeAmount02: 502, feeAmount03: 5022, feeNo: '01', feeType: '01'}
      ]
      this.crossItemList = [
        {feeNo: '01', deptId: 1000001, feeName: '学费', feeType: '01', feeTypeDesc: '', statusCode: '01', statusCodeDesc: '', remark: '', sortNo: '01'},
        {feeNo: '02', deptId: 1000001, feeName: '伙食费', feeType: '02', feeTypeDesc: '', statusCode: '01', statusCodeDesc: '', remark: '', sortNo: '02'},
        {feeNo: '03', deptId: 1000001, feeName: '住宿费', feeType: '02', feeTypeDesc: '', statusCode: '01', statusCodeDesc: '', remark: '', sortNo: '03'}
      ]
      // 界面配置表
      this.uiSetList = [
        {uiSetId: 'tbPm_Fee_Kd_07', uiSetName: '费用信息管理', uiSetType: '01', uiSetTypeDesc: '', colWidthOpt: '300', exportTextSet: '', crossItemNo: 'feeNo', crossItemName: 'feeName', mergeCell: '', remark: '', itemList: null}
      ]
      // 界面配置子表
      this.uiSetItemList = [
        {uiSetId: 'tbPm_Fee_Kd_07', columnName: 'feeAmount01', columnDesc: '主费用', columnProp: 'feeAmount01', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '0', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''},
        {uiSetId: 'tbPm_Fee_Kd_07', columnName: 'feeAmount02', columnDesc: '伙食费', columnProp: 'feeAmount02', isVisible: '0', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '01', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''},
        {uiSetId: 'tbPm_Fee_Kd_07', columnName: 'feeAmount03', columnDesc: '取暖费', columnProp: 'feeAmount03', isVisible: '0', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '01', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''},
        {uiSetId: 'tbPm_Fee_Kd_07', columnName: 'Term', columnDesc: '账期', columnProp: 'term', isVisible: '1', isVisibleDesc: '', sortNo: '03', queryCondition: '1', queryConditionDesc: '', sortNoQuery: '03', controlType: '01', controlTypeDesc: '', typeId: '', defaultValue: '', required: '1', requiredDesc: '', isUnique: '1', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '', alignType: 'left', formatString: '', columnType: '01', buttonType: '01', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: ''}
      ]
      this.setVisible('01')
    }
  },
  watch: {
    'form.studentType': 'changeStuType'
  },
  methods: {
    setVisible: function (showType) {
      if (showType === '01') { // 新生登录显示
        this.idCardVisible = true
        this.studentNoVisible = false
      }
      if (showType === '02') { // 老生登录显示
        this.idCardVisible = false
        this.studentNoVisible = true
      }
    },
    changeStuType: function () {
      this.form.studentName = ''
      this.form.studentNo = ''
      this.form.idCard = ''
      if (this.form.studentType === '01') {
        // this.form.studentType = '02'
        // this.$alert('新生缴费系统暂时关闭！')
        this.setVisible('01')
        // this.setVisible('02')
      } else {
        this.setVisible('02')
      }
    },
    // 初始化查询条件窗体
    initQueryForm: function () {
      console('暂时不做处理。。。')
    },
    // 获取待缴费账单（核准状态）
    loginInit: function () {
      if (process.env.NODE_ENV === 'production') {
        if (this.form.studentType === '01') {
          if (this.form.studentName === '' || this.form.idCard === '') {
            this.$alert('学生姓名或者身份证号不能为空！')
          } else {
            this.newStulogin()
          }
        } else {
          if (this.form.studentName === '' || this.form.studentNo === '') {
            this.$alert('学生姓名或者学号不能为空！')
          } else {
            this.oldStulogin()
          }
        }
      } else {
        if (this.form.studentType === '01') {
          if (this.form.studentName === '' || this.form.idCard === '') {
            this.$alert('学生姓名或者身份证号不能为空！')
          } else {
            this.newStulogin()
          }
        } else {
          if (this.form.studentName === '' || this.form.studentNo === '') {
            this.$alert('学生姓名或者学号不能为空！')
          } else {
            this.oldStulogin()
          }
        }
      }
    },
    // 老生查询登录
    oldStulogin: function () {
      if (process.env.NODE_ENV === 'production') {
        var self = this
        // 初始化
        let request = {}
        request.idIf = '59'
        request.deptId = 0
        request.itemList = [
          {paramName: 'studentNo', paramValue: self.form.studentNo.trim()},
          {paramName: 'studentName', paramValue: self.form.studentName.trim()}
        ]
        this.axios.post('/iif/accessIfForHttp', request
        )
        .then(function (response) {
          if (response.data.result.success === true) {
            if (response.data.responseObj.studentList.length > 0) {
              self.global.curStudent = response.data.responseObj.studentList[0]
              // 处理学生信息
              self.addStudent()
              self.global.curStudent.studentType = self.form.studentType
              console.log('curStudent:', self.global.curStudent)
              self.$router.push('/MyBillXiFan')
              self.route = [{ path: '/MyBillXiFan', component: require('./MyBillXiFan.vue'), meta: { title: '账单信息' } }]
              self.$router.addRoutes(self.route)
            } else {
              self.$alert('登录信息有误！')
            }
          } else {
            self.$alert('登录信息有误！')
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.global.studentType = this.form.studentType
        this.$router.push('/MyBillXiFan')
        this.route = [{ path: '/MyBillXiFan', component: require('./MyBillXiFan.vue'), meta: { title: '账单信息' } }]
        this.$router.addRoutes(this.route)
      }
    },
    addStudent: function () {
      var self = this
      this.axios.post('/college/addViXFStudent', this.global.curStudent)
      .then(function (response) {
        if (response.data.result.success === true) {
          console.log('处理学生信息成功！', self.global.curStudent)
        } else {
          console.log('处理学生信息失败！', self.global.curStudent)
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    // 新生查询登录
    newStulogin: function () {
      var self = this
      if (process.env.NODE_ENV === 'production') {
        this.axios.get('/college/getViXFStudentForLogin', {
          params: {
            userName: self.form.studentName.trim(),
            userPwd: self.form.idCard.trim()
          }
        })
        .then(function (response) {
          if (response.data.result.success === true) {
            if (response.data.viXFStudentList.length > 0) { // 登录成功
              self.global.curStudent = response.data.viXFStudentList[0]
              console.log('curStudent:', self.global.curStudent)
              self.$router.push('/MyBillXiFanNew')
              self.route = [{ path: '/MyBillXiFanNew', component: require('./MyBillXiFanNew.vue'), meta: { title: '新生缴费' } }]
              self.$router.addRoutes(self.route)
            } else {
              self.$alert('姓名或者身份证号不正确！')
            }
          } else {
            self.$alert('系统错误！')
          }
        }, response => {
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        self.$router.push('/MyBillXiFanNew')
        self.route = [{ path: '/MyBillXiFanNew', component: require('./MyBillXiFanNew.vue'), meta: { title: '新生缴费' } }]
        self.$router.addRoutes(self.route)
      }
    }
  }
}
</script>

<style>
/*********通用bottom************/
.tybottom{width:1000px; height:236px; margin:10px auto;}
.main{ width:1000px;margin:0 auto;}
.main_down{width: 1000px;height: 200px;margin:10 auto;}
.down_gg{width: 490px;height: 200px;border: 1px solid #eaeaea;} 
.down_gg h2{font-style: normal;color: red;height: 40px;line-height: 40px;padding-left: 20px;font-size:16px;margin-bottom: 10px;}
.gg li{padding-left: 30px;height: 30px;line-height: 30px;font-size: 14px;color: #6a6b6c;}
.bzzx li {padding-left: 30px;height: 30px;line-height: 30px;font-size: 14px;color: #6a6b6c;}
.bzzx  a{color:#fe8f0d;}
.bzzx  a:hover{text-decoration: underline;}
.fl{float: left;}
.fr{float:right;}
  .content{ margin-top:15px;}

  /* .content .login{ background:url(../images/login_head.png) top left no-repeat; width:212px; float:right; padding-top:37px;} */
  .content .login div{ border:1px solid #EAEAEA; border-top:none; width:208px; height:175px;margin-left:1px; padding:15px 0;}
  .content .login .txt{ width:125px; border:1px solid #D0D0D0; height:25px;}


  .content .login table{ width:200px; height:170px; margin-left:10px;}
  .content .banner{ float:left; width:520px; height:239px; border:1px solid #CCCBCB; padding:1px; margin-left:10px;}
  .content .banner img{ width:520px; height:239px;}

  .content .tzgg{ width:236px; height:238px; float:left; padding-top:7px; padding-left:6px;border:1px solid #D4D4D2;}
  .content .tzgg .top_one{height:100px; padding-right:5px;}
  .content .tzgg .top_one img{ width:109px; height:86px; border:1px solid #D4D4D2; padding:1px; margin-right:5px; float:left;}
  .content .tzgg .top_one .title{ color:#FF0000; line-height:27px;}
  .content .tzgg .top_one .detail{ color:#FF0000; }

  .content .tzgg .list { margin-top:10px; margin-left:5px;}
  .content .tzgg .list li{ padding-left:0px;  line-height:25px; height:25px;}
  .content .tzgg .list li img{ margin-bottom:3px; margin: 2px,2px,2px,2px;}

  .content .program{ margin-top:15px;}
  .content .program a{ display:block; width:143px; height:132px; float:left; border:1px solid #DDDDDD; margin-right:25px;}
  .content .program img{ width:143px; height:132px; }

  .content .other{ margin-top:15px;}
  .content .other a{ display:block; width:303px; height:107px; float:left; border:1px solid #DDDDDD; margin-right:18px; background:#F9F9F9; padding:8px;}

  .footer{ height:120px; margin-top:15px; text-align:center;}
  .footer .copyright{ margin:10px auto; font-size:14px;}
  .footer .bs a{ margin:0 5px;}


  /*登陆页*/

  .content .h2{ text-align:center; color:#003B93; font-weight:600; font-size:25px; margin-top:40px; margin-bottom:35px;}

  .content .jf{ height:350px; border:1px solid #E9E9E9; padding:1px;}

  .content .jf .dlck{ width:350px; height:280px; border:1px solid #CECECE; background:#F4F4F4; margin-top:8px; margin-left:8px; padding:15px; font-size:14px; font-weight:400; line-height:30px;}
  .content .jf .dlck .h3{text-align:center; color:#FF0000; font-weight:600; font-size:20px; padding-top:20px;}

  .content .jf .dlck .ts{ height:55px; border-bottom:1px dashed #666666; text-align:center; margin-top:15px;}
  .content .jf .dlck p{ text-align:center;}

  .content .jf .dlck dl{ margin-top:20px;}
  .content .jf .dlck .dd{ width:345px; height:30px; margin-bottom:18px;}
  /* .Copy{width:100%0px; height:200px; margin:0px auto; font-size:12px; color:#666666; text-align:center; line-height:200%; margin-top:10px; background-color: #fff} */

</style>


// WEBPACK FOOTER //
// LoginXiFan.vue?8606c398